import '../animations/_selectric';

$( document ).ready(function() {
    let select = $('select');
    select.selectric();
});